<template>
    <div>
        <v-dialog v-model="dialogShow" persistent width="1600" class="dialog myScrollArea">
            <v-card>
                <v-card-title class="dialogTitle">
                    <p class="dialogTitle-title">导入数据</p>
                    <v-spacer></v-spacer>
                    <p @click="closeDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
                </v-card-title>
                <v-card-text style="overflow:auto;" class="myScrollArea">
                    <div style="width:100%;height:690px;margin-top:20px;display:flex;">
                        <!--左侧操作区-->
                        <div style="width:440px;height:100%;">
                            <!--数据列表-->
                            <div style="width:100%;height:440px;box-shadow:0 2px 7px rgba(166, 166, 166, 0.25);">
                                <!--顶部切换-->
                                <div style="width:100%;height:70px;border-bottom:1px solid #E5E5E5;padding:20px 25px 0 20px;display:flex;">
                                    <div @click="selectDataAreaTab( '我的数据')" class="dataAreaTab">
                                         <p :style="{'color':dataAreaTab === '我的数据' ? '#000000' : '#A7A7A7','font-weight':dataAreaTab === '我的数据' ? 'bold' : ''}"
                                           class="dataAreaTab_text">我的数据</p>
                                        <div :style="{'display':dataAreaTab === '我的数据' ? 'block' : 'none'}" class="dataAreaTab_line"></div>
                                    </div>
                                    <!--       @click="dataAreaTab = '我的收藏'"         -->
                                    <div @click="selectDataAreaTab( '我的收藏')"  style="margin-left:22px;" class="dataAreaTab">
                                        <p :style="{'color':dataAreaTab === '我的收藏' ? '#000000' : '#A7A7A7','font-weight':dataAreaTab === '我的收藏' ? 'bold' : ''}"
                                           class="dataAreaTab_text">我的收藏</p>
                                        <div :style="{'display':dataAreaTab === '我的收藏' ? 'block' : 'none'}" class="dataAreaTab_line"></div>
                                    </div>
                                    <v-spacer></v-spacer>

                                    <v-btn @click="rightDataArea = '素材库'" dark height="32" depressed color="#1976D2">
                                        <p style="font-size:16px;"><span style="margin-right:8px;" class="iconfontFamily">&#xe6a4;</span>素材库</p>
                                    </v-btn>

                                </div>
                                <div style="width:100%;height:70px;padding:0 25px 0 25px">
                                    <v-layout class="ma-0" align-center justify-center fill-height>
                                        <div style="width: 390px;height: 36px">
                                            <v-text-field
                                                    v-model="searchAnnexWord"
                                                    class="annexTextField"
                                                    outlined
                                                    dense
                                                    append-icon="mdi-magnify"
                                                    placeholder="在我的附件中搜索"
                                                    @keyup.enter.native="enterAnnexSearch"
                                            ></v-text-field>
                                        </div>
                                    </v-layout>
                                </div>
                                <div v-if="dataAreaTab === '我的数据'" style="width:100%;height: calc(100% - 140px);">
                                    <div v-if="annexList.length === 0" style="width: 100%;height:100%">
                                        <v-layout class="ma-0" align-center justify-center fill-height>
                                            <div style="height: 22px;display: flex">
                                                <div style="line-height: 22px;color: rgba(166, 166, 166, 1);font-size: 22px" class="iconfontFamily">&#xe691;</div>
                                                <div style="margin-left: 12px;line-height: 22px;color: rgba(166, 166, 166, 1)">{{searchAnnexWord !==''? '未搜索到相关内容':'暂无内容'}}</div>
                                            </div>
                                        </v-layout>
                                    </div>
                                    <div v-else style="width: 100%;height: 100%;padding: 0 25px;overflow-y: auto;overflow-x: hidden;" class="myAnnexData">
                                        <template v-for="(item,index) in  annexList">
                                            <div :key="index+'myData'" style="width: 390px;height: 60px;border-radius: 5px;
                                            margin-bottom: 15px;cursor: pointer" @click="selectAnnex(item.annexId)" :style="{'border':selectAnnexId === item.annexId ? '1px solid rgba(25, 118, 210, 1)':'1px solid rgba(229,229,229,1)'}">
                                                <v-layout class="ma-0" fill-height>
                                                    <div style="height: 100%;width: 91px;">
                                                        <v-layout class="ma-0" fill-height align-center>
                                                            <img v-if="item.suffix === 'csv'" src="../../../assets/globe/import_annex/csv.png" style="width: 45px;height: 41px;margin-left: 20px" />
                                                            <img v-if="item.suffix === 'xls'" src="../../../assets/globe/import_annex/xls.png" style="width: 45px;height: 41px;margin-left: 20px" />
                                                            <img v-if="item.suffix === 'xlsx'" src="../../../assets/globe/import_annex/xlsx.png" style="width: 45px;height: 41px;margin-left: 20px" />
                                                        </v-layout>
                                                    </div>
                                                    <div style="height: 100%;width: 183px;padding: 7px 0;">
                                                        <div style="display: flex;width:100%" v-if="!item.isShow">
                                                            <v-tooltip bottom color="rgba(229, 229, 229, 0.75)" v-if="item.name.length > 8">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <div v-bind="attrs" v-on="on" style="width: 111px;height: 22px;white-space: nowrap;text-overflow: ellipsis;overflow:hidden;color: black;line-height: 22px">
                                                                        {{item.name.substring(0,8)+'...'}}</div>
                                                                </template>
                                                                <span style="color: black">{{item.name}}</span>
                                                            </v-tooltip>
                                                            <div v-else  style="height: 22px;color: black;line-height: 22px" >{{item.name}}</div>
                                                            <div style="line-height: 22px;margin-left: 10px;color: black;cursor: pointer" class="iconfontFamily" @click="isEditAnnexName(item,$event)">&#xe693;</div>
                                                        </div>
                                                        <div v-else style="display: flex;width:100%">
                                                            <div style="height: 26px;width: 162px"></div>
                                                        </div>
                                                        <div style="display: flex;margin-top: 8px;font-size: 12px;color: rgba(136, 136, 136, 1)">
                                                            <div style="line-height: 17px">{{(item.annexSize/(1024*1024)).toFixed(1)}}MB</div>
                                                            <div style="width: 1px;height: 17px;background: rgba(136, 136, 136, 1);margin-left: 6px"></div>
                                                            <div style="line-height: 17px;margin-left: 6px">{{item.gmtCreatetime.substring(0,item.gmtCreatetime.length-3)}}</div>
                                                            <v-tooltip bottom color="transparent" v-if="item.formError !== 0" :nudge-right="item.formError === 2 ? '37':'71'" nudge-top="15">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <div v-bind="attrs" v-on="on" style="line-height: 17px;color: rgba(255, 195, 0, 1);font-size: 12px;margin-left: 5px" class="iconfontFamily">&#xe69c;</div>
                                                                </template>
                                                                <div style="height: 49px;background: transparent;position: relative">
                                                                    <div style="height: 39px;border-radius: 10px;line-height: 39px;background: white;padding: 0 10px;border: 1px solid rgba(255,195,0,1);color: black;margin-top: 9px">{{ item.formError === 2 ? '文件不符合数据模版':'文件可能存在部分数据解析有误'}}</div>
                                                                    <div style="width: 15px;height: 15px;border-left: 1px solid rgba(255,195,0,1);border-top: 1px solid rgba(255,195,0,1);background: white;position: absolute;top: -7px;left: 28px;transform: rotateZ(45deg)"></div>
                                                                </div>
                                                            </v-tooltip>
                                                        </div>
                                                    </div>
                                                    <div style="height: 100%;width: 116px">
                                                        <v-layout class="ma-0" fill-height align-center>
                                                            <v-tooltip top color="rgba(229, 229, 229, 0.75)">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <div v-on="on" v-bind="attrs" style="width: 26px;height:26px;line-height: 26px;cursor:pointer;border-radius: 6px;" @click="downLink(item,$event)">
                                                                        <v-hover v-slot="{ hover }">
                                                                            <div style="width: 26px;height:26px;cursor:pointer;border-radius: 6px;" :style="{'background': hover? 'rgba(229, 229, 229, 1)':''}">
                                                                                <v-layout class="ma-0" fill-height align-center justify-center>
                                                                                    <div style="font-size:20px;" :style="{'color': hover? 'rgba(0, 183, 255, 1)' :'#000000'}" class="iconfontFamily">&#xe694;</div>
                                                                                </v-layout>
                                                                            </div>
                                                                        </v-hover>
                                                                    </div>
                                                                </template>
                                                                <span style="color: black">下载</span>
                                                            </v-tooltip>
                                                            <div style="font-size:20px;color: rgba(229, 229, 229, 1);margin-left: 17px" class="iconfontFamily">&#xe695;</div>
                                                            <v-tooltip top color="rgba(229, 229, 229, 0.75)">
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <div v-on="on" v-bind="attrs" style="width: 26px;height:26px;line-height: 26px;cursor:pointer;border-radius: 6px;margin-left: 17px" @click="deleteAnnex(item,$event)">
                                                                        <v-hover v-slot="{ hover }">
                                                                            <div style="width: 26px;height:26px;cursor:pointer;border-radius: 6px;" :style="{'background': hover? 'rgba(229, 229, 229, 1)':''}">
                                                                                <v-layout class="ma-0" fill-height align-center justify-center>
                                                                                    <div style="font-size:20px;" :style="{'color': hover? 'rgba(252, 0, 0, 1)' :'#000000'}" class="iconfontFamily">&#xe696;</div>
                                                                                </v-layout>
                                                                            </div>
                                                                        </v-hover>
                                                                    </div>
                                                                </template>
                                                                <span style="color: black">删除</span>
                                                            </v-tooltip>
                                                        </v-layout>
                                                    </div>
                                                </v-layout>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                                <div v-if="dataAreaTab === '我的收藏'" style="width:100%;height: calc(100% - 140px);">
                                    <v-layout class="ma-0" align-center justify-center fill-height>
                                        <div style="height: 22px;display: flex">
                                            <div style="line-height: 22px;color: rgba(166, 166, 166, 1);font-size: 22px" class="iconfontFamily">&#xe691;</div>
                                            <div style="margin-left: 12px;line-height: 22px;color: rgba(166, 166, 166, 1)">暂无内容</div>
                                        </div>
                                    </v-layout>
                                </div>

                            </div>
                            <!--数据上传-->
                            <div style="width:100%;height:calc(100% - 440px - 20px);margin-top:20px;box-shadow:0 2px 7px rgba(166, 166, 166, 0.25);padding:20px;">
                                <div>
                                    <v-layout class="ma-0" justify-space-between>
                                        <div style="height: 25px;display: flex">
                                            <div style="font-size:18px;font-weight:bold;color:#000000;;line-height: 25px">上传数据</div>
<!--                                            <div style="font-size:16px;color: rgba(166, 166, 166, 1);line-height: 25px;margin-left: 8px" class="iconfontFamily">&#xe6a2;</div>-->
                                        </div>
                                        <div style="height: 25px;display: flex;width: 101px;cursor: pointer" @click="downDataTemplate">
                                            <div style="font-size:12px;color: rgba(25, 118, 210, 1);line-height: 25px;" class="iconfontFamily">&#xe6a1;</div>
                                            <div style="font-size:14px;color:rgba(25, 118, 210, 1);line-height: 25px;margin-left: 5px">数据模版下载</div>
                                        </div>
                                    </v-layout>
                                </div>
                                <div style="position:relative;width:calc(100% - 10px);height:135px;border:1px dashed #e5e5e5;margin:15px auto 0 auto;" @drop="reportDrop">
                                    <div style="width:100%;height:100%;display:flex;flex-direction: column;align-items: center;">
                                        <p style="margin-top:23px;line-height:33px;font-size:48px;color:#e5e5e5;" class="iconfontFamily">&#xe6a9;</p>
                                        <p style="margin-top:18px;font-size:16px;color:#000000;">
                                            <span style="color:#1976D2;">点击上传</span>
                                            按钮或将您的文件拖放到此处
                                        </p>
                                        <p style="margin-top:5px;font-size:12px;color:#888888;">.csv/.xlsx/.xls</p>
                                    </div>
                                    <input ref="uploadDataInput" @change="clickUploadSource()" type="file"
                                           style="position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;cursor:pointer;">
                                </div>
                            </div>
                        </div>

                        <!--右侧展示区-->
                        <div style="width: 1160px;height:100%;margin-left:20px;box-shadow:0 2px 7px rgba(166, 166, 166, 0.25);">
                            <div v-if="rightDataArea === '素材库'" style="width: 100%;height: 100%">
                                <v-layout class="ma-0" fill-height align-center justify-center>
                                    <div style="font-size: 20px;height: 28px;line-height: 28px;color: rgba(166, 166, 166, 1)">暂无内容，敬请期待</div>
                                </v-layout>
                            </div>
                            <div v-if="rightDataArea === '数据区'" style="width: 100%;height: 100%">
                                <div v-if="selectAnnexId === ''" style="width: 100%;height: 100%">
                                    <v-layout class="ma-0" fill-height align-center justify-center>
                                        <div style="font-size: 20px;height: 28px;line-height: 28px;color: rgba(166, 166, 166, 1)">请选择要预览的数据文件</div>
                                    </v-layout>
                                </div>
                                <div v-else style="width: 100%;height: 100%;display: flex">
                                    <!--左侧表格区-->
                                    <div style="height: 100%;width: 820px;padding: 18px 0 0 18px">
                                        <!--配置项-->
                                        <div style="height: 36px;width: 100%;border-radius: 8px;border: 1px solid rgba(229,229,229, 1)">
                                            <v-layout class="ma-0" fill-height align-center justify-space-between>
                                                <div style="display: flex">
                                                    <div style="margin-left: 15px;line-height: 24px;color: black">您已配置：</div>
                                                    <template v-for="(item,index) in configArray">
                                                        <div :key="index+'config'" style="height: 22px;min-width: 64px;border-radius: 4px;background: rgba(245, 238, 230, 1);margin-left: 14px">
                                                            <v-layout class="ma-0" fill-height align-center justify-space-around>
                                                                <div style="line-height: 20px;font-size: 14px;margin-left: 8px;color: black">
                                                                    {{item.use}}<span v-if="item.use !=='数值'" style="color: red">*</span>
                                                                </div>
                                                                <div @click="deleteConfig(item)" style="line-height: 20px;font-size: 8px;color: black;cursor: pointer;margin-left: 6px;margin-right: 8px" class="iconfontFamily">&#xe659;</div>
                                                            </v-layout>
                                                        </div>
                                                    </template>

                                                    <template  v-for="(item,index) in configNoArray">
                                                        <div v-if="!isConfigAll" :key="index+'configNo'" style="height: 22px;min-width: 50px;border-radius: 4px;border: 1px dashed rgba(166,166,166,1);margin-left: 14px">
                                                            <v-layout class="ma-0" fill-height align-center justify-center>
                                                                <div style="line-height: 20px;font-size: 14px;margin-left: 8px;margin-right: 8px;color: black">
                                                                    {{item.use}}<span v-if="item.use !=='数值'" style="color: red">*</span>
                                                                </div>
                                                            </v-layout>
                                                        </div>
                                                    </template>
                                                </div>

                                                <div style="display: flex">
                                                    <div v-if="!isConfigAll" style="line-height: 18px;font-size: 12px;color: red;">必选配置未完成</div>
                                                    <div v-else style="line-height: 18px;font-size: 12px;color: rgba(67, 207, 124, 1);"><span style="line-height: 18px;margin-right: 12px" class="iconfontFamily">&#xe69b;</span>必选配置已完成</div>
                                                    <div style="margin-left: 24px;margin-right: 15px;line-height: 18px;font-size: 12px;cursor: pointer" :style="{'color':configArray.length !==0 ? 'rgba(42, 130, 228, 1)':'rgba(166, 166, 166, 1)'}" @click="configArray.length !==0 ? emptyConfig():''">清空</div>
                                                </div>
                                            </v-layout>
                                        </div>
                                        <!--表格-->
                                        <div style="width: 100%;height: 585px;margin-top: 16px;overflow-x: auto" class="myTableData">
                                            <!--表头-->
                                            <div style="width: 100%;display: flex" :style="{'height':configArray.length !== 0 ? '69px':'40px '}">
                                                <div :style="{'width':200*selectAnnexCol+'px'}" style="display: flex">
                                                    <template v-for="(item,index) in tableHeadList">
                                                        <div :key="index+'table'" style="width: 200px;height: 100%;border: 1px solid rgba(229,229,229,1);" >
                                                            <div style="display: flex;justify-content: space-between">
                                                                <div style="line-height: 40px;color: black;margin-left: 15px;">{{item.text.length > 10 ? item.text.substring(0,8)+'...':item.text}} </div>
                                                                <v-menu bottom nudge-bottom="30" :nudge-left="layerAreaType === 'point' ? '82' :'104'">
                                                                    <template v-slot:activator="{ on, attrs }">
                                                                        <div v-on="on" v-bind="attrs" class="iconfontFamily" style="line-height: 40px;color: rgba(166, 166, 166, 1);margin-right: 15px">&#xe650;</div>
                                                                    </template>
                                                                    <v-card v-if="layerAreaType === 'point'" style="width: 165px;height: 264px;font-size: 14px;color: black;padding: 15px 0 0 15px">
                                                                        <div>设置为：</div>
                                                                        <div style="height: 20px;width: 66px;display: flex;margin-left: 16px;margin-top: 15px;cursor: pointer" @click="selectPointConfig('经度',item)">
                                                                            <div v-if="item.use !== '经度'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">经度<span style="color: red;">*</span></div>
                                                                        </div>
                                                                        <div style="height: 20px;width: 66px;display: flex;margin-left: 16px;margin-top: 12px;cursor: pointer" @click="selectPointConfig('纬度',item)">
                                                                            <div v-if="item.use !== '纬度'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">纬度<span style="color: red;">*</span></div>
                                                                        </div>
                                                                        <div style="height: 1px;width: 105px;background: rgba(229, 229, 229, 1);margin: 8px 0 8px 16px"></div>
                                                                        <div style="height: 20px;width: 112px;display: flex;margin-left: 16px;margin-top: 12px;cursor: pointer" @click="selectPointConfig('(经度,纬度)',item)">
                                                                            <div v-if="item.use !== '(经度,纬度)'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">(经度,纬度)<span style="color: red;">*</span></div>
                                                                        </div>
                                                                        <div style="height: 1px;width: 105px;background: rgba(229, 229, 229, 1);margin: 8px 0 8px 16px"></div>
                                                                        <div style="height: 20px;width: 112px;display: flex;margin-left: 16px;margin-top: 12px;cursor: pointer" @click="selectPointConfig('(纬度,经度)',item)">
                                                                            <div v-if="item.use !== '(纬度,经度)'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">(纬度,经度)<span style="color: red;">*</span></div>
                                                                        </div>
                                                                        <div style="height: 1px;width: 105px;background: rgba(229, 229, 229, 1);margin: 8px 0 8px 16px"></div>

                                                                        <div style="height: 20px;width: 66px;display: flex;margin-left: 16px;margin-top: 15px;cursor: pointer" @click="selectPointConfig('数值',item)">
                                                                            <div v-if="item.use !== '数值'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">数值</div>
                                                                        </div>
                                                                    </v-card>

                                                                    <v-card v-if="layerAreaType === 'line'" style="width: 209px;height: 480px;font-size: 14px;color: black;padding: 15px 0 0 15px">
                                                                        <div>设置为：</div>
                                                                        <!--四个点-->
                                                                        <div style="height: 20px;width: 112px;display: flex;margin-left: 16px;margin-top: 15px;cursor: pointer" @click="selectLineConfig('起点经度',item)">
                                                                            <div v-if="item.use !== '起点经度'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">起点经度<span style="color: red;">*</span></div>
                                                                        </div>
                                                                        <div style="height: 20px;width: 112px;display: flex;margin-left: 16px;margin-top: 12px;cursor: pointer" @click="selectLineConfig('起点纬度',item)">
                                                                            <div v-if="item.use !== '起点纬度'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">起点纬度<span style="color: red;">*</span></div>
                                                                        </div>

                                                                        <div style="height: 20px;width: 112px;display: flex;margin-left: 16px;margin-top: 12px;cursor: pointer" @click="selectLineConfig('终点经度',item)">
                                                                            <div v-if="item.use !== '终点经度'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">终点经度<span style="color: red;">*</span></div>
                                                                        </div>
                                                                        <div style="height: 20px;width: 112px;display: flex;margin-left: 16px;margin-top: 12px;cursor: pointer" @click="selectLineConfig('终点纬度',item)">
                                                                            <div v-if="item.use !== '终点纬度'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">终点纬度<span style="color: red;">*</span></div>
                                                                        </div>

                                                                        <div style="height: 1px;width: 148px;background: rgba(229, 229, 229, 1);margin: 8px 0 8px 16px"></div>
                                                                        <!--两个点-->
                                                                        <div style="height: 20px;width: 148px;display: flex;margin-left: 16px;margin-top: 12px;cursor: pointer" @click="selectLineConfig('起点(经度,纬度)',item)">
                                                                            <div v-if="item.use !== '起点(经度,纬度)'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">起点(经度,纬度)<span style="color: red;">*</span></div>
                                                                        </div>
                                                                        <div style="height: 20px;width: 148px;display: flex;margin-left: 16px;margin-top: 12px;cursor: pointer" @click="selectLineConfig('终点(经度,纬度)',item)">
                                                                            <div v-if="item.use !== '终点(经度,纬度)'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">终点(经度,纬度)<span style="color: red;">*</span></div>
                                                                        </div>

                                                                        <div style="height: 1px;width: 148px;background: rgba(229, 229, 229, 1);margin: 8px 0 8px 16px"></div>
                                                                        <!--两个点-->
                                                                        <div style="height: 20px;width: 148px;display: flex;margin-left: 16px;margin-top: 12px;cursor: pointer" @click="selectLineConfig('起点(纬度,经度)',item)">
                                                                            <div v-if="item.use !== '起点(纬度,经度)'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">起点(纬度,经度)<span style="color: red;">*</span></div>
                                                                        </div>
                                                                        <div style="height: 20px;width: 148px;display: flex;margin-left: 16px;margin-top: 12px;cursor: pointer" @click="selectLineConfig('终点(纬度,经度)',item)">
                                                                            <div v-if="item.use !== '终点(纬度,经度)'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">终点(纬度,经度)<span style="color: red;">*</span></div>
                                                                        </div>
                                                                        <!--一个点-->
                                                                        <div style="height: 1px;width: 148px;background: rgba(229, 229, 229, 1);margin: 8px 0 8px 16px"></div>

                                                                        <div style="height: 20px;width: 154px;display: flex;margin-left: 16px;margin-top: 12px;cursor: pointer" @click="selectLineConfig('坐标串(经度,纬度)',item)">
                                                                            <div v-if="item.use !== '坐标串(经度,纬度)'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">坐标串(经度,纬度)<span style="color: red;">*</span></div>
                                                                        </div>
                                                                        <div style="height: 1px;width: 148px;background: rgba(229, 229, 229, 1);margin: 8px 0 8px 16px"></div>
                                                                        <div style="height: 20px;width: 154px;display: flex;margin-left: 16px;margin-top: 12px;cursor: pointer" @click="selectLineConfig('坐标串(纬度,经度)',item)">
                                                                            <div v-if="item.use !== '坐标串(纬度,经度)'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">坐标串(纬度,经度)<span style="color: red;">*</span></div>
                                                                        </div>
                                                                        <div style="height: 1px;width: 148px;background: rgba(229, 229, 229, 1);margin: 8px 0 8px 16px"></div>

                                                                        <div style="height: 20px;width: 66px;display: flex;margin-left: 16px;margin-top: 12px;cursor: pointer" @click="selectLineConfig('数值',item)">
                                                                            <div v-if="item.use !== '数值'" class="iconfontFamily" style="font-size: 12px;color: rgba(196, 196, 196, 1);line-height: 20px">&#xe69f;</div>
                                                                            <div v-else class="iconfontFamily" style="font-size: 12px;color: rgba(42, 130, 228, 1);line-height: 20px">&#xe6a0;</div>
                                                                            <div style="margin-left: 8px;color: black;font-size: 14px">数值</div>
                                                                        </div>
                                                                    </v-card>
                                                                </v-menu>
                                                            </div>
                                                            <div style="display: flex" v-if="item.use !== ''">
                                                                <div  style="height: 22px;min-width: 64px;border-radius: 4px;background: rgba(245, 238, 230, 1);margin-left: 14px;display: flex;">
                                                                    <div style="line-height: 22px;font-size: 14px;margin-left: 8px;color: black">
                                                                        {{item.use}}<span v-if="item.use !=='数值'" style="color: red">*</span>
                                                                    </div>
                                                                    <div @click="deleteTableConfig(item)" style="line-height: 22px;font-size: 8px;color: black;cursor: pointer;margin-left: 6px;margin-right: 8px" class="iconfontFamily">&#xe659;</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>

                                            </div>
                                            <!--表格数据-->
                                            <template v-for="(item,index) in selectAnnexData">
                                                    <div :key="index+'tr'" style="height: 32px;background: rgba(229, 229, 229, 0.3);display: flex;color: black" :style="{'background': index % 2 === 0 ? 'white':'rgba(229, 229, 229, 0.3)','width':200*selectAnnexCol+'px'}">
                                                        <template v-for="(col,key) in item">
                                                                <div :key="key+'th'" v-if="col !==''" style="width: 200px;height: 32px;border-left: 1px solid rgba(229, 229, 229, 1);border-right: 1px solid rgba(229, 229, 229, 1);padding-left: 6px">
                                                                    <el-tooltip  effect="light"  placement="top-end">
                                                                        <div style="height: 32px;line-height: 32px;white-space: nowrap;text-overflow: ellipsis;overflow:hidden;min-width: 30px">{{col}}</div>
                                                                        <div slot="content" style="max-width: 800px">{{col}}</div>
                                                                    </el-tooltip>
                                                                </div>
                                                            <div v-else :key="key+'th'" style="min-width: 200px;height: 32px;border-left: 1px solid rgba(229, 229, 229, 1);border-right: 1px solid rgba(229, 229, 229, 1);line-height: 32px;white-space: nowrap;text-overflow: ellipsis;overflow:hidden;padding-left: 6px">
                                                                {{col}}
                                                            </div>
                                                        </template>
                                                    </div>
                                                </template>
                                        </div>
                                        <div style="width: 100%;margin-top: 8px;height: 20px;display: flex">
                                            <div class="iconfontFamily" style="line-height: 20px;color: rgba(166, 166, 166, 1);font-size: 12px">&#xe6a2;</div>
                                            <div style="font-size: 14px;color: rgba(166, 166, 166, 1);line-height: 20px">此处仅展示前20条数据用于数据配置。此文件共有{{selectAnnexDataTotalRow}}行数据，解析失败<span style="color: red">0</span>行。</div>
                                        </div>
                                    </div>
                                    <!--右侧切换区-->
                                    <div style="height: 100%;width: 280px;padding: 20px 25px 0 25px">
                                        <!--顶部按钮区-->
                                        <div style="height: 32px;width: 100%">
                                            <v-layout class="ma-0" justify-center>
                                                <div style="width: 96px;height: 32px;border-radius: 4px;background: rgba(25, 118, 210, 1);position: relative">
                                                    <div style="width: 100%;height: 100%;line-height: 32px;color: white;text-align: center">更新数据</div>
                                                    <input ref="updateTableInput" value="" type="file" style="position: absolute;left: 0;top: 0;width: 96px;height: 32px;opacity:0;cursor: pointer" @change="updateTable" >
                                                </div>

                                                <div style="width: 96px;height: 32px;border-radius: 4px;cursor: pointer;line-height: 32px;color: white;margin-left: 16px;text-align: center" :style="{'background':isConfigAll ? 'rgba(25, 118, 210, 1)':'rgba(25, 118, 210, 0.65)' }" @click="isConfigAll ? createLayer():''">生成图层 </div>
                                            </v-layout>
                                        </div>
                                        <!--图层切换-->
                                        <div style="margin-top: 18px;width: 100%;display: flex;justify-content: center">
                                            <div @click="selectLayerType('point')" class="layerAreaTab">
                                                <div :style="{'color':layerAreaType === 'point' ? '#000000' : '#A6A6A6',}"
                                                   class="layerAreaTab_text">点类图层</div>
                                                <div :style="{'display':layerAreaType === 'point' ? 'block' : 'none'}" class="layerAreaTab_line"></div>
                                            </div>
                                            <!--       @click="dataAreaTab = '我的收藏'"         -->
                                            <div @click="selectLayerType('line')"  style="margin-left:24px;" class="layerAreaTab">
                                                <div :style="{'color':layerAreaType === 'line' ? '#000000' : '#A7A7A7'}"
                                                   class="layerAreaTab_text">线类图层</div>
                                                <div :style="{'display':layerAreaType === 'line' ? 'block' : 'none'}" class="layerAreaTab_line"></div>
                                            </div>
                                        </div>
                                        <!--五种不同显示类型-->
                                        <div v-if="layerAreaType === 'point'" style="width: 100%;margin-top: 24px;height: 148px">
                                            <div style="width: 100%">
                                                <v-layout class="ma-0" justify-space-between>
                                                    <img @click="layerTypeSelect = 'square'" :src="layerTypeSelect === 'square' ? require('../../../assets/globe/import_annex/square_selected.png') : require('../../../assets/globe/import_annex/square.png')" style="width: 100px;height: 65px;border-radius: 6px;cursor: pointer;" :style="{'border': layerTypeSelect === 'square' ? '2px solid rgba(25,118,210,1)':''}" />
                                                    <img @click="layerTypeSelect = 'heatMap'" :src="layerTypeSelect === 'heatMap' ? require('../../../assets/globe/import_annex/heatMap_selected.png') : require('../../../assets/globe/import_annex/heatMap.png')" style="width: 100px;height: 65px;border-radius: 6px;cursor: pointer;" :style="{'border': layerTypeSelect === 'heatMap' ? '2px solid rgba(25,118,210,1)':''}" />
                                                </v-layout>
                                            </div>
                                            <img @click="layerTypeSelect = 'histogram'" :src="layerTypeSelect === 'histogram' ? require('../../../assets/globe/import_annex/histogram_selected.png') : require('../../../assets/globe/import_annex/histogram.png')" style="width: 100px;height: 65px;border-radius: 6px;cursor: pointer;margin-top: 20px" :style="{'border': layerTypeSelect === 'histogram' ? '2px solid rgba(25,118,210,1)':''}" />
                                        </div>
                                        <div v-if="layerAreaType === 'line'" style="width: 100%;margin-top: 24px;height: 148px">
                                            <div style="width: 100%">
                                                <v-layout class="ma-0" justify-space-between>
                                                    <img @click="layerTypeSelect = '2Dline'" :src="layerTypeSelect === '2Dline' ? require('../../../assets/globe/import_annex/2Dline_selected.png') : require('../../../assets/globe/import_annex/2Dline.png')" style="width: 100px;height: 65px;border-radius: 6px;cursor: pointer;" :style="{'border': layerTypeSelect === '2Dline' ? '2px solid rgba(25,118,210,1)':''}" />
                                                    <img @click="layerTypeSelect = '3Dline'" :src="layerTypeSelect === '3Dline' ? require('../../../assets/globe/import_annex/3Dline_selected.png') : require('../../../assets/globe/import_annex/3Dline.png')" style="width: 100px;height: 65px;border-radius: 6px;cursor: pointer;" :style="{'border': layerTypeSelect === '3Dline' ? '2px solid rgba(25,118,210,1)':''}" />
                                                </v-layout>
                                            </div>

                                        </div>
                                        <div style="width: 100%;margin-top: 104px">
                                            <img v-if="layerTypeSelect === 'square'" src="../../../assets/globe/import_annex/square_example.png" style="width: 230px;height: 120px;border-radius: 4px">
                                            <div v-if="layerTypeSelect === 'square'" style="width: 100%;margin-top: 18px;font-size: 14px;line-height: 19px">网格图是指用方格的形式对地理空间上的数值数据进行展示和呈现，支持数据聚合，每个网格区域中对具体数值进行直观呈现。
                                                网格图易于理解，数值信息简单直观，可以清晰的展示数据在地理空间的分布、差异情况。</div>
                                            <img v-if="layerTypeSelect === 'heatMap'" src="../../../assets/globe/import_annex/heatmap_example.png" style="width: 230px;height: 120px;border-radius: 4px">
                                            <div v-if="layerTypeSelect === 'heatMap'" style="width: 100%;margin-top: 18px;font-size: 14px;line-height: 19px">热力图是指用经度和纬度表示的两个分类字段确定数值点的位置，
                                                通过相应位置的颜色去表现数值的大小，颜色深代表的数值大。热力图易于理解，数据信息直观有效，可以清晰地呈现数据在地理空间的分布、频率或密度情况。</div>

                                            <img v-if="layerTypeSelect === 'histogram'" src="../../../assets/globe/import_annex/histogram_example.png" style="width: 230px;height: 120px;border-radius: 4px">
                                            <div v-if="layerTypeSelect === 'histogram'" style="width: 100%;margin-top: 18px;font-size: 14px;line-height: 19px">柱状图是一种以柱体的高度为变量的统计图表，由一系列高度不等的柱体表示数据分布的情况，
                                                用来比较两个或以上的数据差异，柱状图易于理解，数据差异表现简答直观，可以清晰的呈现数据在地理空间的分布、差异情况。</div>

                                            <img v-if="layerTypeSelect === '2Dline'" src="../../../assets/globe/import_annex/2Dline_example.png" style="width: 230px;height: 120px;border-radius: 4px">
                                            <div v-if="layerTypeSelect === '2Dline'" style="width: 100%;margin-top: 18px;font-size: 14px;line-height: 19px">连线图是用直线将地图中的两点进行连接，可以清晰的呈现地理空间中各数据点位之间的关系，
                                                可用于地铁线路图、出发地目的地展示等场景。</div>

                                            <img v-if="layerTypeSelect === '3Dline'" src="../../../assets/globe/import_annex/3Dline_example.png" style="width: 230px;height: 120px;border-radius: 4px">
                                            <div v-if="layerTypeSelect === '3Dline'" style="width: 100%;margin-top: 18px;font-size: 14px;line-height: 19px">3D连线图是用曲线对3D地图中的两点进行连接，可以清晰的呈现地理空间中各数据点位之间的关系，可用于飞机航线图、出发地目的地展示等场景。</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--文件名字弹窗-->
        <v-dialog v-model="fileNameDialogShow" persistent width="520">
            <v-card>
                <v-card-title class="dialogTitle">
                    <p class="dialogTitle-title">数据信息</p>
                    <v-spacer></v-spacer>
                    <p @click="closeFileNameDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
                </v-card-title>
                <v-card-text>
                    <div style="width: 100%;height: 230px;padding: 30px 7px 0 25px">
                        <div style="display: flex;height: 22px">
                            <div style="color: black;line-height: 22px">文件大小</div>
                            <div style="margin-left: 32px;line-height: 22px;color: black;">{{(this.uploadFile.size/(1024*1024)).toFixed(1)}}MB</div>
                        </div>
                        <div style="height: 40px;margin-top: 30px;display: flex">
                            <div style="color: black;line-height: 36px">文件名称</div>
                            <div style="width: 340px;height: 36px;margin-left: 32px;">
                                <v-text-field
                                        v-model="fileName"
                                        class="fileNameTextField"
                                        outlined
                                        height="36"
                                        style="font-size: 14px;color: rgba(166, 166, 166, 1)"
                                        dense
                                        color="rgba(217, 217, 217, 1)"
                                >
                                    <template v-slot:append>
                                        <div style="font-size: 14px;color: rgba(166, 166, 166, 1);margin-top: 4px">{{fileName.length}}/20</div>
                                    </template>
                                </v-text-field>
                            </div>
                        </div>
                        <div style="height: 18px;display: flex;margin-left: 88px" v-if="fileName.length > 20">
                            <div class="iconfontFamily" style="color: rgba(252, 0, 0, 1);font-size: 12px;line-height: 18px">&#xe6a2;</div>
                            <div style="margin-left: 6px;line-height: 18px;font-size: 12px;color: rgba(252, 0, 0, 1)">附件名称长度超出上限</div>
                        </div>
                        <div v-else style="height: 18px;display: flex;margin-left: 95px"></div>
                        <div style="height: 35px;margin-top: 39px;width: 100%">
                            <v-layout class="ma-0" justify-end>
                                <div style="width: 100px;height: 35px;cursor: pointer;background: rgba(30, 58, 138, 1);text-align: center;line-height: 35px;color: white" @click="sureUploadFile">确定上传</div>
                            </v-layout>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--上传文件提示弹窗-->
        <v-dialog v-model="continueUploadDialogShow" persistent width="520">
            <v-card>
                <v-card-title class="dialogTitle">
                    <p class="dialogTitle-title">数据信息</p>
                    <v-spacer></v-spacer>
                    <p @click="closeContinueUploadDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
                </v-card-title>
                <v-card-text>
                    <div style="width: 100%;height: 215px;padding: 30px  5px 0 20px">
                        <div v-if="continueUploadDialogType === 1" style="font-size: 20px;line-height: 28px;margin-left: 30px;color: black">此文件中可能存在部分数据解析有误</div>
                        <div v-if="continueUploadDialogType === 1" style="font-size: 14px;line-height: 20px;margin-left: 30px;color: rgba(166, 166, 166, 1);margin-top: 24px">注意：数据解析有误会可能导致无法正确生成图层。</div>
                        <div v-if="continueUploadDialogType === 2" style="font-size: 20px;line-height: 28px;color: black">此文件与数据模版不符，确定继续上传吗？</div>
                        <div v-if="continueUploadDialogType === 2" style="font-size: 14px;line-height: 20px;color: rgba(166, 166, 166, 1);margin-top: 24px">注意：不符合模版的文件可能会导致解析失败，无法正确生成可视化图层。</div>
                        <div style="color: rgba(25, 118, 210, 1);font-size: 14px;display: flex;width: 110px;margin-top: 12px;cursor: pointer" :style="{'margin-left':continueUploadDialogType === 1 ? '30px':'0px'}" @click="downDataTemplate">
                            <div class="iconfontFamily" style="line-height: 21px">&#xe6a1;</div>
                            <div style="line-height: 21px;margin-left: 5px">数据模版下载</div>
                        </div>
                        <div style="height: 35px;margin-top: 45px;display: flex;justify-content: end">
                                <div style="height: 32px;width: 100px;background: rgba(30, 58, 138, 1);cursor: pointer;line-height: 35px;text-align: center;color: white" @click="continueUpload">继续上传</div>
                                <div style="position:relative;margin-left: 24px;height: 32px;width: 100px;background: rgba(30, 58, 138, 1);cursor: pointer">
                                    <div style="height: 32px;width: 100px;line-height: 32px;text-align: center;color: white;">更换文件</div>
                                    <input ref="changeAnnexInput" @change="changeFile()" type="file" style="position:absolute;top:0;left:0;width:100px;height:32px;opacity:0;cursor:pointer;" >
                                </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--删除弹窗-->
        <v-dialog v-model="deleteAnnexDialogShow" persistent width="520">
            <v-card>
                <v-card-title class="dialogTitle">
                    <p class="dialogTitle-title">提示</p>
                    <v-spacer></v-spacer>
                    <p @click="closeDeleteAnnexDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
                </v-card-title>
                <v-card-text>
                    <div style="width: 100%;height: 215px;padding: 35px  7px 0 20px">
                        <div style="font-size: 20px;line-height: 28px;margin-left: 20px;color: black">确认要删除此数据文件吗？</div>
                        <div style="font-size: 14px;line-height: 20px;margin-left: 20px;color: rgba(166, 166, 166, 1);margin-top: 24px">注意：数据文件删除后，由此文件生成的图层将无法查看数据。</div>
                        <div style="height: 35px;margin-top: 52px">
                            <v-layout class="ma-0" justify-end>
                                <div style="height: 35px;width: 100px;background: rgba(30, 58, 138, 1);cursor: pointer;line-height: 35px;text-align: center;color: white" @click="sureDeleteAnnex">确定</div>
                                <div style="height: 35px;width: 100px;background: rgba(245, 245, 245, 1);cursor: pointer;line-height: 35px;text-align: center;color: black;margin-left: 24px" @click="closeDeleteAnnexDialog">取消</div>
                            </v-layout>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--覆盖数据弹窗-->
        <v-dialog v-model="coverDataDialogShow" persistent width="520">
            <v-card>
                <v-card-title class="dialogTitle">
                    <p class="dialogTitle-title">提示</p>
                    <v-spacer></v-spacer>
                    <p @click="closeCoverDataDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
                </v-card-title>
                <v-card-text>
                    <div style="width: 100%;height: 216px;padding: 45px 7px 0 30px">
                        <div style="font-size: 20px;line-height: 28px;margin-left: 10px;color: black">选择新图层类别将会覆盖已有配置。</div>
                        <div style="margin-top: 35px;margin-left: 10px;width: 100px">
                            <v-checkbox v-model="noAlert"
                                        hide-details
                                        dense
                                        class="ma-0"
                            >
                                <template v-slot:label>
                                    <div style="color: black;font-size: 14px">不再提醒</div>
                                </template>
                            </v-checkbox>
                        </div>
                        <div style="height: 35px;margin-top: 36px">
                            <v-layout class="ma-0" justify-end>
                                <div style="height: 35px;width: 100px;background: rgba(30, 58, 138, 1);cursor: pointer;line-height: 35px;text-align: center;color: white" @click="sureSelectLayerType">确定</div>
                                <div style="height: 35px;width: 100px;background: rgba(245, 245, 245, 1);cursor: pointer;line-height: 35px;text-align: center;color: black;margin-left: 24px" @click="closeCoverDataDialog">取消</div>
                            </v-layout>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--覆盖配置弹窗-->
        <v-dialog v-model="coverConfigDialogShow" persistent width="520">
            <v-card>
                <v-card-title class="dialogTitle">
                    <p class="dialogTitle-title">提示</p>
                    <v-spacer></v-spacer>
                    <p @click="closeConfigDataDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
                </v-card-title>
                <v-card-text>
                    <div style="width: 100%;height: 216px;padding: 34px 7px 0 30px">
                        <div style="font-size: 20px;line-height: 28px;margin-left: 10px;color: black">选择新的必填配置项组将会覆盖原有配置。</div>
                        <div style="font-size: 14px;line-height: 20px;margin-left: 10px;color: rgba(166, 166, 166, 1);margin-top: 24px">分界线前后的必填项组为互斥关系。</div>
                        <div style="margin-top: 12px;margin-left: 10px;width: 100px">
                            <v-checkbox v-model="noAlert"
                                        hide-details
                                        dense
                                        class="ma-0"
                            >
                                <template v-slot:label>
                                    <div style="color: black;font-size: 14px">不再提醒</div>
                                </template>
                            </v-checkbox>
                        </div>
                        <div style="height: 35px;margin-top: 26px">
                            <v-layout class="ma-0" justify-end>
                                <div style="height: 35px;width: 100px;background: rgba(30, 58, 138, 1);cursor: pointer;line-height: 35px;text-align: center;color: white" @click="sureCoverConfig">确定</div>
                                <div style="height: 35px;width: 100px;background: rgba(245, 245, 245, 1);cursor: pointer;line-height: 35px;text-align: center;color: black;margin-left: 24px" @click="closeConfigDataDialog">取消</div>
                            </v-layout>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--修改名称弹窗-->
        <v-dialog v-model="modifyAnnexNameDialogShow" persistent width="520">
            <v-card>
                <v-card-title class="dialogTitle">
                    <p class="dialogTitle-title">修改文件名称</p>
                    <v-spacer></v-spacer>
                    <p @click="closeModifyAnnexNameDialog" class="dialogTitle-close iconfontFamily">&#xe60d;</p>
                </v-card-title>
                <v-card-text>
                    <div style="width: 100%;height: 154px;padding: 40px 7px 0 25px">
                        <div style="height: 36px;width: 100%;display: flex">
                            <div style="color: black;line-height: 36px">文件名称</div>
                            <div style="height: 36px;width: 339px;margin-left: 32px">
                                <v-text-field
                                        v-model="annexNameField"
                                        class="fileNameTextField"
                                        outlined
                                        height="36"
                                        style="font-size: 14px;color: rgba(166, 166, 166, 1)"
                                        dense
                                        color="rgba(217, 217, 217, 1)"
                                >
                                    <template v-slot:append>
                                        <div style="font-size: 14px;color: rgba(166, 166, 166, 1);margin-top: 4px">{{annexNameField.length}}/20</div>
                                    </template>
                                </v-text-field>
                            </div>
                        </div>
                        <div style="height: 35px;margin-top: 43px">
                            <v-layout class="ma-0" justify-end>
                                <div style="height: 35px;width: 100px;background: rgba(30, 58, 138, 1);cursor: pointer;line-height: 35px;text-align: center;color: white" @click="sureEditAnnexName">确定</div>
                                <div style="height: 35px;width: 100px;background: rgba(245, 245, 245, 1);cursor: pointer;line-height: 35px;text-align: center;color: black;margin-left: 24px" @click="closeModifyAnnexNameDialog">取消</div>
                            </v-layout>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        name: "ImportAnnexData",
        props:["dialogShow","isView"],
        data(){
            return{
                dataAreaTab:"我的数据",
                rightDataArea:'数据区',
                searchAnnexWord:'',
                annexList:[
                    {
                        "annexId": "f4d0a2d9dbbf47d094d8525a92176299",
                        "annexSize": 53671,
                        "gmtCreatetime": "2023-10-23 13:50:12",
                        "link": "https://market.obs.cn-north-4.myhuaweicloud.com:443/annex/c6e6a6a7119840008c1cbe9389fb657d.xlsx",
                        "name": "副本线文件-经纬度坐标串格式2.xlsx",
                        "suffix": "xlsx",
                        "userId": "1667281618053440",
                        "isShow":false
                    },
                ],//
                annexNameField:'',//弹窗修改名称
                annexNameSelectId:'',//选中的Id
                modifyAnnexNameDialogShow:false,
                annexListLength :0,
                annexListTotalCapacity:0,
                uploadFile:'',
                fileNameDialogShow:false,
                fileName:'',
                uploadFileId:'',
                continueUploadDialogShow:false,
                continueUploadDialogType:1,
                deleteAnnexDialogShow:false,
                deleteAnnexId:'',
                selectAnnexId:"",
                layerAreaType:'point',
                layerTypeSelect:'square',//  1 square 2 heatMap 3 Histogram  4 2Dline 5 3dline

                //配置 的数据结构
                configArray:[
                    {col:1,use:'经度'},
                    {col:5,use:'纬度'},
                ], //配置项塞进去的数组
                configNoArray:[
                    {use:'经纬度'},
                ], //配置未完成的数据
                isConfigAll:false,//是否配置完全
                selectAnnexRow:0,//行数
                selectAnnexCol:0,//列数
                selectAnnexData:[],//选中的数据
                selectAnnexDataTotalRow:0, //总行数
                tableHeadList:[],//表头数据
                configType:1,// 0初始状态  点图层 1 (单点) 2 (经度，纬度) 3 (纬度，经度)
                updateType:'change',
                coverDataDialogShow:false,
                noAlert:false,
                coverConfigDialogShow:false,
                coverConfigDialogTemp:{col:0,use:''},
                isViewMyAnnex:this.isView,
                defaultColUse:[],
            }
        },
        methods: {
            closeDialog() {
                this.$emit("closeDialog", "")
            },
            closeFileNameDialog() {
                this.fileNameDialogShow = false
                this.uploadFile = ''
                this.$refs.uploadDataInput.value = ''
            },
            closeContinueUploadDialog() {
                this.continueUploadDialogShow = false
                this.uploadFile = ''
                this.$refs.uploadDataInput.value = '';
            },
            closeDeleteAnnexDialog() {
                this.deleteAnnexDialogShow = false
                this.deleteAnnexId = ''
            },
            closeCoverDataDialog(){
                this.coverDataDialogShow = false
                this.noAlert = false
            },
            closeConfigDataDialog(){
                this.coverConfigDialogShow = false
                this.coverConfigDialogTemp={col:0,use:''}
                this.noAlert = false
            },
            closeModifyAnnexNameDialog(){
                this.annexNameField = ''
                this.annexNameSelectId = ''
                this.modifyAnnexNameDialogShow = false
            },
            //火狐拖拽上传
            reportDrop(event){
                event.preventDefault()
                const file = event.dataTransfer.files[0];
                this.uploadSource(file)
            },
            //是否编辑附件名字
            isEditAnnexName(item,event){
                event.stopPropagation()
                this.annexNameField = item.name
                this.annexNameSelectId = item.annexId
                this.modifyAnnexNameDialogShow = true
            },
            sureEditAnnexName(){
                if(this.annexNameField.length > 20){
                    this.$store.state.snackbarShow = true
                    this.$store.state.snackbarText = "附件名称长度超出上限"
                    this.$store.state.snackbarType = 'error'
                }else{
                    let data = new FormData()
                    data.append('annexId',this.annexNameSelectId)
                    data.append('name',this.annexNameField)
                    this.$axios.post('/authorApi/userAnnex/editAnnexName',data)
                        .then((res)=>{
                            if(res.data.status === 200){
                                this.closeModifyAnnexNameDialog()
                                this.getAnnexList('')
                            }else{
                                this.$store.state.snackbarShow = true
                                this.$store.state.snackbarText = "修改失败"
                                this.$store.state.snackbarType = 'error_red'
                            }

                        }).catch(()=>{
                        this.$store.state.snackbarShow = true
                        this.$store.state.snackbarText = "修改失败"
                        this.$store.state.snackbarType = 'error_red'
                        this.closeModifyAnnexNameDialog()
                    })
                }
            },
            selectDataAreaTab(val) {
                this.dataAreaTab = val
                this.rightDataArea = '数据区'
            },
            downDataTemplate() {
                const downloadLink = document.createElement('a');
                downloadLink.href = 'https://market.obs.cn-north-4.myhuaweicloud.com/%E6%A0%87%E5%87%86%E6%A0%B7%E4%BE%8B%E6%95%B0%E6%8D%AE.zip';
                document.body.appendChild(downloadLink);
                downloadLink.click(); // 模拟用户点击下载链接
                document.body.removeChild(downloadLink);
            },
            //搜索
            enterAnnexSearch() {
                if (this.dataAreaTab === '我的数据') {
                    this.getAnnexList(this.searchAnnexWord)
                }
            },
            clickUploadSource(){
                let file = this.$refs.uploadDataInput.files[0];
                this.uploadSource(file)
            },
            //上传到服务器
            uploadSource(file) {
                //csv   text/csv
                //xls  application/vnd.ms-excel
                //xlsx application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
                //判断类型
                this.uploadFile = ''
                this.uploadFileId = ''
                this.updateType = 'change'
                if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel" && file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                    this.$store.state.snackbarShow = true
                    this.$store.state.snackbarText = "数据文件格式不支持"
                    this.$store.state.snackbarType = 'error_red'
                    this.$refs.uploadDataInput.value = '';
                } else if (file.size > 1024 * 1024 * 10) {
                    this.$store.state.snackbarShow = true
                    this.$store.state.snackbarText = "数据文件大小超出限制"
                    this.$store.state.snackbarType = 'error_red'
                    this.$refs.uploadDataInput.value = '';
                } else if (this.annexListLength >= 10) {
                    this.$store.state.snackbarShow = true
                    this.$store.state.snackbarText = "数据文件数量已达上限"
                    this.$store.state.snackbarType = 'error_red'
                    this.$refs.uploadDataInput.value = '';
                } else {
                    //弹窗填写文件名
                    this.uploadFile = file
                    this.fileName = file.name.substring(0,file.name.lastIndexOf("."))
                    this.fileNameDialogShow = true
                }
            },
            sureUploadFile() {
                if (this.fileName.length <= 20) {
                    this.fileNameDialogShow = false
                    this.$emit('setLoading')
                    let data = new FormData()
                    data.append('file', this.uploadFile)
                    data.append('annexName', this.fileName)
                    data.append('annexId', this.uploadFileId)
                    this.$axios.post('/authorApi//userAnnex/addUserAnnex', data).then((res) => {
                        if (res.data.status === 200) {
                            if (res.data.data.formError === 0) {
                                //拉数据跟新列表
                                this.getAnnexList('')
                                this.uploadFileId = ''
                            } else if (res.data.data.formError === 1) {
                                //弹窗， 数据解析有误
                                this.continueUploadDialogType = 1
                                this.continueUploadDialogShow = true
                                this.uploadFileId = res.data.data.annexId
                            } else if (res.data.data.formError === 2) {
                                //弹窗，模板有误弹窗
                                this.continueUploadDialogType = 2
                                this.continueUploadDialogShow = true
                                this.uploadFileId = res.data.data.annexId
                            }
                        } else {
                            this.$store.state.snackbarShow = true
                            this.$store.state.snackbarText = res.data.message
                            this.$store.state.snackbarType = 'error_red'
                        }
                        this.fileName = ''
                        this.$emit('closeLoading')
                        this.$refs.uploadDataInput.value = '';
                    }).catch(() => {
                        this.fileName = ''
                        this.$emit('closeLoading')
                        this.$refs.uploadDataInput.value = '';
                    })
                }

            },
            //继续上传
            continueUpload() {
                this.continueUploadDialogShow = false
                this.uploadFile = ''

                if(this.updateType === 'change'){
                    this.getAnnexList('')
                }
                else
                    this.updateAnnexList(this.uploadFileId)
            },
            //更换文件
            changeFile() {
                this.continueUploadDialogShow = false
                this.uploadFile = ''
                this.$refs.uploadDataInput.value = '';
                let file = this.$refs.changeAnnexInput.files[0];
                if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel" && file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                    this.$store.state.snackbarShow = true
                    this.$store.state.snackbarText = "数据文件格式不支持"
                    this.$store.state.snackbarType = 'error_red'
                    this.$refs.changeAnnexInput.value = '';
                } else if (file.size > 1024 * 1024 * 10) {
                    this.$store.state.snackbarShow = true
                    this.$store.state.snackbarText = "数据文件大小超出限制"
                    this.$store.state.snackbarType = 'error_red'
                    this.$refs.changeAnnexInput.value = '';
                }  else {
                   //上传文件部分
                    this.changeUploadFile(file)
                }
            },
            changeUploadFile(file) {
                    this.$emit('setLoading')
                    let data = new FormData()
                    data.append('file', file)
                    data.append('annexId', this.uploadFileId)
                    this.$axios.post('/authorApi//userAnnex/addUserAnnex', data).then((res) => {
                        if (res.data.status === 200) {
                            if (res.data.data.formError === 0) {
                                //拉数据跟新列表
                                if(this.updateType === 'change'){
                                    this.getAnnexList('')
                                }
                                else
                                    this.updateAnnexList(this.uploadFileId)
                            } else if (res.data.data.formError === 1) {
                                //弹窗， 数据解析有误
                                this.continueUploadDialogType = 1
                                this.continueUploadDialogShow = true
                                this.uploadFileId = res.data.data.annexId
                            } else if (res.data.data.formError === 2) {
                                //弹窗，模板有误弹窗
                                this.continueUploadDialogType = 2
                                this.continueUploadDialogShow = true
                                this.uploadFileId = res.data.data.annexId
                            }
                        } else {
                            this.$store.state.snackbarShow = true
                            this.$store.state.snackbarText = res.data.message
                            this.$store.state.snackbarType = 'error_red'
                        }
                        this.$emit('closeLoading')
                        this.$refs.changeAnnexInput.value = '';
                    }).catch(() => {
                        this.$emit('closeLoading')
                        this.$refs.changeAnnexInput.value = '';
                    })
            },

            //更新表格
            updateTable(){
                this.updateType = 'update'
                let file = this.$refs.updateTableInput.files[0];
                if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel" && file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                    this.$store.state.snackbarShow = true
                    this.$store.state.snackbarText = "数据文件格式不支持"
                    this.$store.state.snackbarType = 'error_red'
                    this.$refs.updateTableInput.value = '';
                } else if (file.size > 1024 * 1024 * 10) {
                    this.$store.state.snackbarShow = true
                    this.$store.state.snackbarText = "数据文件大小超出限制"
                    this.$store.state.snackbarType = 'error_red'
                    this.$refs.updateTableInput.value = '';
                } else {
                    //上传文件部分
                    this.updateUploadFile(file)
                }
            },
            updateUploadFile(file){
                this.$emit('setLoading')
                let data = new FormData()
                data.append('file', file)
                data.append('annexId', this.selectAnnexId)
                this.$axios.post('/authorApi//userAnnex/addUserAnnex', data).then((res) => {
                    if (res.data.status === 200) {
                        if (res.data.data.formError === 0) {
                            //拉数据跟新列表
                            this.updateAnnexList(res.data.data.annexId)
                        } else if (res.data.data.formError === 1) {
                            //弹窗， 数据解析有误
                            this.continueUploadDialogType = 1
                            this.continueUploadDialogShow = true
                            this.uploadFileId = res.data.data.annexId
                        } else if (res.data.data.formError === 2) {
                            //弹窗，模板有误弹窗
                            this.continueUploadDialogType = 2
                            this.continueUploadDialogShow = true
                            this.uploadFileId = res.data.data.annexId
                        }
                    } else {
                        this.$store.state.snackbarShow = true
                        this.$store.state.snackbarText = res.data.message
                        this.$store.state.snackbarType = 'error_red'
                    }
                    this.$emit('closeLoading')
                    this.$refs.updateTableInput.value = '';
                }).catch(() => {
                    this.$emit('closeLoading')
                    this.$refs.updateTableInput.value = '';
                })
            },
            updateAnnexList(id){
                this.$axios.get('/authorApi/userAnnex/getZUserAnnexList', {
                    params: {
                        title: ''
                    }
                }).then((res) => {
                    if (res.data.status === 200) {
                        this.annexList = res.data.data.annexList
                        this.annexListTotalCapacity = res.data.data.allLength
                        this.annexListLength = res.data.data.allNumber
                        this.selectAnnex(id)
                    } else {
                        this.$store.state.snackbarShow = true
                        this.$store.state.snackbarText = '数据拉取失败，请稍后再试'
                        this.$store.state.snackbarType = 'error'
                    }
                })
            },

            getAnnexList(keyword) {
                this.$axios.get('/authorApi/userAnnex/getZUserAnnexList', {
                    params: {
                        title: keyword
                    }
                }).then((res) => {
                    if (res.data.status === 200) {
                        this.annexList = res.data.data.annexList
                        this.annexListTotalCapacity = res.data.data.allLength
                        this.annexListLength = res.data.data.allNumber

                        if(this.isViewMyAnnex){
                            this.viewAnnexDialogData()
                            this.isViewMyAnnex =false
                        }else{
                            this.selectAnnexId = ''
                        }
                    } else {
                        this.$store.state.snackbarShow = true
                        this.$store.state.snackbarText = '数据拉取失败，请稍后再试'
                        this.$store.state.snackbarType = 'error'
                    }
                })
            },
            downLink(item, event) {
                event.stopPropagation()
                this.downloadFun(item.name, item.annexId, item.suffix)
            },
            deleteAnnex(item, event) {
                event.stopPropagation()
                this.deleteAnnexDialogShow = true
                this.deleteAnnexId = item.annexId
            },
            sureDeleteAnnex() {
                this.deleteAnnexDialogShow = false
                let data = new FormData()
                data.append('annexId', this.deleteAnnexId)
                this.$axios.post('/authorApi/userAnnex/deleteZUserAnnexById', data)
                    .then((res) => {
                        if (res.data.status === 200) {
                            this.$store.state.snackbarShow = true
                            this.$store.state.snackbarText = "附件删除成功"
                            this.$store.state.snackbarType = 'success'
                            this.getAnnexList(this.searchAnnexWord)
                        } else {
                            this.$store.state.snackbarShow = true
                            this.$store.state.snackbarText = "附件删除失败"
                            this.$store.state.snackbarType = 'error_red'
                        }
                        this.deleteAnnexId = ''
                    }).catch(() => {
                    this.deleteAnnexId = ''
                    this.$store.state.snackbarShow = true
                    this.$store.state.snackbarText = "附件删除失败"
                    this.$store.state.snackbarType = 'error_red'
                })
            },

            downloadFun(name, link, suffix) {
                const pp = '/authorApi/userAnnex/downloadById?annexId=' + link
                let filename = name + "." + suffix
                const downloadLink = document.createElement('a');
                downloadLink.href = pp;
                downloadLink.download = filename
                document.body.appendChild(downloadLink);
                downloadLink.click(); // 模拟用户点击下载链接
                document.body.removeChild(downloadLink);
            },
            //选择附件
            selectAnnex(id) {
                this.updateType = 'change'
                this.uploadFileId = ''
                this.selectAnnexId = id
                this.rightDataArea = '数据区'
                this.$emit('setLoading')
                this.configArray = []
                this.configNoArray = []
                this.isConfigAll = false
                this.$axios.get('/authorApi/userAnnex/readAnnex', {
                    params: {
                        annexId: id
                    }
                }).then((res) => {
                    //关闭loading
                    this.$emit('closeLoading')
                    if (res.data.status === 200) {
                        this.selectAnnexRow = res.data.data.height
                        this.selectAnnexCol = res.data.data.weight
                        this.selectAnnexData = res.data.data.lists
                        this.selectAnnexDataTotalRow = res.data.data.totalCol
                        this.layerAreaType =  res.data.data.type
                        this.layerTypeSelect = res.data.data.type === 'point' ? 'square':'2Dline'
                        this.defaultColUse = res.data.data.defaultColUse
                        //生成数组
                        this.createArray(res.data.data.tableTitleList)
                    } else {
                        this.$store.state.snackbarShow = true
                        this.$store.state.snackbarText = "数据获取失败"
                        this.$store.state.snackbarType = 'error_red'
                    }

                }).catch(() => {
                    this.$store.state.snackbarShow = true
                    this.$store.state.snackbarText = "数据获取失败"
                    this.$store.state.snackbarType = 'error_red'
                })
            },
            createArray(val) {
                this.tableHeadList = []
                for (let i = 0; i < val.length; i++) {
                    this.tableHeadList.push({
                        col: i,
                        use: '',
                        text:val[i]
                    })
                }
              this.defaultColUse.forEach((item) => {
                this.tableHeadList[item['col']].use = item['use']
              })
              this.configArray = this.defaultColUse
              if (this.layerAreaType === 'point') {
                this.checkPointConfig()
              } else if(this.layerAreaType === 'line') {
                this.checkLineConfig()
              }
            },
            //选择图层种类
            selectLayerType(val) {
                let isShow = window.localStorage.getItem('isShowCoverDataDialog')
                if(isShow){
                    if(val!== this.layerAreaType){
                        this.layerAreaType = val
                        this.layerTypeSelect = this.layerAreaType === 'point' ? 'square':'2Dline'
                        this.configArray = []
                        this.configNoArray = []
                        this.isConfigAll = false
                        this.tableHeadList = this.tableHeadList.map((item)=>{
                            item.use=''
                            return item
                        })
                    }
                }else{
                    if(val!== this.layerAreaType)
                        this.coverDataDialogShow = true
                }
            },
            sureSelectLayerType(){
                if(this.noAlert){
                    window.localStorage.setItem('isShowCoverDataDialog',true)
                }
                this.layerAreaType = this.layerAreaType ==='point' ? 'line':'point'
                this.layerTypeSelect = this.layerAreaType === 'point' ? 'square':'2Dline'
                this.closeCoverDataDialog()
                this.configArray = []
                this.configNoArray = []
                this.isConfigAll = false
                this.tableHeadList = this.tableHeadList.map((item)=>{
                    item.use=''
                    return item
                })
            },

            deleteTableConfig(item) {
                if(this.layerAreaType === 'point')
                    this.pointPushConfigArray('',item.col)
                else
                    this.linePushConfigArray('',item.col)
            },
            deleteConfig(element) {
                this.configArray = this.configArray.filter(item=>item !=element)
                this.configToTable()
                if(this.layerAreaType === 'point')
                    this.checkPointConfig()
                else
                    this.checkLineConfig()
            },
            //清空配置数据
            emptyConfig() {
                this.configArray = []//配置数组清空
                this.configNoArray = []
                this.isConfigAll = false
                this.tableHeadList = this.tableHeadList.map((item) => {
                    item.use = ''
                    return item
                })
            },
            //确定覆盖
            sureCoverConfig(){
                if(this.noAlert){
                    window.localStorage.setItem('isShowCoverConfigDialog',true)
                }
                if(this.layerAreaType === 'point'){
                    this.pointPushConfigArray(this.coverConfigDialogTemp.use,this.coverConfigDialogTemp.col)
                }else{
                    this.linePushConfigArray(this.coverConfigDialogTemp.use,this.coverConfigDialogTemp.col)
                }

                this.closeConfigDataDialog()
            },
            //选择点配置项
            selectPointConfig(val,item){
                let isShow = window.localStorage.getItem('isShowCoverConfigDialog')
                let temp = false
                if(isShow){
                    temp = false
                }else{
                   temp = this.judgePointConflict(val,item.col)
                }
                if(temp){
                    //弹窗
                    this.coverConfigDialogShow = true
                    this.coverConfigDialogTemp.col = item.col
                    this.coverConfigDialogTemp.use = val
                }else{
                    if (item.use === '') {
                        this.pointPushConfigArray(val,item.col)
                    } else {
                        if (item.use === val) {
                            this.pointPushConfigArray('',item.col)
                        } else {
                            this.pointPushConfigArray(val,item.col)
                        }
                    }
                }
            },
            pointPushConfigArray(val,col){
                for(let i = 0;i<this.configArray.length;i++){
                    if(col ===this.configArray[i].col){
                        this.configArray.splice(i, 1)
                    }
                }
                //判断冲突移除
                if(val !==''){
                    for(let i = 0;i<this.configArray.length;i++){
                        if(val === '经度'){
                            if(this.configArray[i].use === '经度' ||this.configArray[i].use ==='(纬度,经度)' || this.configArray[i].use ==='(经度,纬度)'){
                                this.configArray.splice(i, 1)
                                i--
                            }
                        }else if(val === '纬度'){
                            if(this.configArray[i].use === '纬度' ||this.configArray[i].use ==='(纬度,经度)' || this.configArray[i].use ==='(经度,纬度)'){
                                this.configArray.splice(i, 1)
                                i--
                            }
                        }else if(val === '数值'){
                            if(this.configArray[i].use === '数值'){
                                this.configArray.splice(i, 1)
                                i--
                            }
                        }else if(val === '(纬度,经度)' ||val === '(经度,纬度)'){
                            if(this.configArray[i].use !== '数值'){
                                this.configArray.splice(i, 1)
                                i--
                            }
                        }
                    }
                    this.configArray.push({col:col, use: val})
                }
                this.configToTable()
                this.checkPointConfig()
            },
            judgePointConflict(val,col){
                for(let i = 0;i<this.configArray.length;i++){
                    if(col !==i){
                        if(val === '经度'){
                            if(this.configArray[i].use === '经度' ||this.configArray[i].use ==='(纬度,经度)' || this.configArray[i].use ==='(经度,纬度)'){
                                return true
                            }
                        }else if(val === '纬度'){
                            if(this.configArray[i].use === '纬度' ||this.configArray[i].use ==='(纬度,经度)' || this.configArray[i].use ==='(经度,纬度)'){
                                return true
                            }
                        }else if(val === '数值'){
                            if(this.configArray[i].use === '数值'){
                                return true
                            }
                        }else if(val === '(纬度,经度)' ||val === '(经度,纬度)'){
                            if(this.configArray[i].use !== '数值'){
                                return true
                            }
                        }
                    }
                }
                return false
            },
            //选择线配置项
            selectLineConfig(val,item){
                let isShow = window.localStorage.getItem('isShowCoverConfigDialog')
                let temp = false
                if(isShow){
                    temp = false
                }else{
                    temp = this.judgeLineConflict(val,item.col)
                }
                if(temp){
                    //弹窗
                    this.coverConfigDialogShow = true
                    this.coverConfigDialogTemp.col = item.col
                    this.coverConfigDialogTemp.use = val
                }else{
                    if (item.use === '') {
                        this.linePushConfigArray(val,item.col)
                    } else {
                        if (item.use === val) {
                            this.linePushConfigArray('',item.col)
                        } else {
                            this.linePushConfigArray(val,item.col)
                        }
                    }
                }


            },
            linePushConfigArray(val,col) {
                for (let i = 0; i < this.configArray.length; i++) {
                    if (col === this.configArray[i].col) {
                        this.configArray.splice(i, 1)
                    }
                }
                //判断重复
                if (val !== '') {
                    for (let i = 0; i < this.configArray.length; i++) {
                        if (val === '起点经度') {
                            if (this.configArray[i].use === '起点经度' || this.configArray[i].use === '起点(纬度,经度)' || this.configArray[i].use === '终点(纬度,经度)'|| this.configArray[i].use === '起点(经度,纬度)' || this.configArray[i].use === '终点(经度,纬度)' || this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                this.configArray.splice(i, 1)
                                i--
                            }
                        }else if (val === '终点经度') {
                            if (this.configArray[i].use === '终点经度' || this.configArray[i].use === '起点(纬度,经度)' || this.configArray[i].use === '终点(纬度,经度)'|| this.configArray[i].use === '起点(经度,纬度)' || this.configArray[i].use === '终点(经度,纬度)' || this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                this.configArray.splice(i, 1)
                                i--
                            }
                        } else if (val === '起点纬度') {
                            if (this.configArray[i].use === '起点纬度' || this.configArray[i].use === '起点(纬度,经度)' || this.configArray[i].use === '终点(纬度,经度)'|| this.configArray[i].use === '起点(经度,纬度)' || this.configArray[i].use === '终点(经度,纬度)' || this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                this.configArray.splice(i, 1)
                                i--
                            }
                        }else if (val === '终点纬度') {
                            if (this.configArray[i].use === '终点纬度' || this.configArray[i].use === '起点(纬度,经度)' || this.configArray[i].use === '终点(纬度,经度)'|| this.configArray[i].use === '起点(经度,纬度)' || this.configArray[i].use === '终点(经度,纬度)' || this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                this.configArray.splice(i, 1)
                                i--
                            }
                        }else if(val === '起点(经度,纬度)'){
                            if (this.configArray[i].use === '起点(经度,纬度)' ||this.configArray[i].use === '起点经度' ||this.configArray[i].use === '终点经度' || this.configArray[i].use === '起点纬度' ||this.configArray[i].use === '终点纬度' || this.configArray[i].use === '起点(纬度,经度)' || this.configArray[i].use === '终点(纬度,经度)'|| this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                this.configArray.splice(i, 1)
                                i--
                            }
                        }else if(val === '终点(经度,纬度)'){
                            if (this.configArray[i].use === '终点(经度,纬度)' ||this.configArray[i].use === '起点经度' ||this.configArray[i].use === '终点经度' || this.configArray[i].use === '起点纬度' ||this.configArray[i].use === '终点纬度' || this.configArray[i].use === '起点(纬度,经度)' || this.configArray[i].use === '终点(纬度,经度)'|| this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                this.configArray.splice(i, 1)
                                i--
                            }
                        }else if(val === '起点(纬度,经度)'){
                            if (this.configArray[i].use === '起点(纬度,经度)' ||this.configArray[i].use === '起点经度' ||this.configArray[i].use === '终点经度' || this.configArray[i].use === '起点纬度' ||this.configArray[i].use === '终点纬度' || this.configArray[i].use === '起点(经度,纬度)' || this.configArray[i].use === '终点(经度,纬度)'|| this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                this.configArray.splice(i, 1)
                                i--
                            }
                        }else if(val === '终点(纬度,经度)'){
                            if (this.configArray[i].use === '终点(纬度,经度)' ||this.configArray[i].use === '起点经度' ||this.configArray[i].use === '终点经度' || this.configArray[i].use === '起点纬度' ||this.configArray[i].use === '终点纬度' || this.configArray[i].use === '起点(经度,纬度)' || this.configArray[i].use === '终点(经度,纬度)'|| this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                this.configArray.splice(i, 1)
                                i--
                            }
                        }else if(val === '坐标串(经度,纬度)' ||val === '坐标串(纬度,经度)'){
                            if(this.configArray[i].use !== '数值'){
                                this.configArray.splice(i, 1)
                                i--
                            }
                        }else if(val === '数值'){
                            if(this.configArray[i].use === '数值'){
                                this.configArray.splice(i, 1)
                                i--
                            }
                        }
                    }
                    this.configArray.push({col: col, use: val})
                }
                this.configToTable()
                this.checkLineConfig()
            },

            judgeLineConflict(val,col){
                for(let i = 0;i<this.configArray.length;i++){
                    if(col !==i){
                        if (val === '起点经度') {
                            if (this.configArray[i].use === '起点经度' || this.configArray[i].use === '起点(纬度,经度)' || this.configArray[i].use === '终点(纬度,经度)'|| this.configArray[i].use === '起点(经度,纬度)' || this.configArray[i].use === '终点(经度,纬度)' || this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                return true
                            }
                        }else if (val === '终点经度') {
                            if (this.configArray[i].use === '终点经度' || this.configArray[i].use === '起点(纬度,经度)' || this.configArray[i].use === '终点(纬度,经度)'|| this.configArray[i].use === '起点(经度,纬度)' || this.configArray[i].use === '终点(经度,纬度)' || this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                return true
                            }
                        } else if (val === '起点纬度') {
                            if (this.configArray[i].use === '起点纬度' || this.configArray[i].use === '起点(纬度,经度)' || this.configArray[i].use === '终点(纬度,经度)'|| this.configArray[i].use === '起点(经度,纬度)' || this.configArray[i].use === '终点(经度,纬度)' || this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                return true
                            }
                        }else if (val === '终点纬度') {
                            if (this.configArray[i].use === '终点纬度' || this.configArray[i].use === '起点(纬度,经度)' || this.configArray[i].use === '终点(纬度,经度)'|| this.configArray[i].use === '起点(经度,纬度)' || this.configArray[i].use === '终点(经度,纬度)' || this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                return true
                            }
                        }else if(val === '起点(经度,纬度)'){
                            if (this.configArray[i].use === '起点(经度,纬度)' ||this.configArray[i].use === '起点经度' ||this.configArray[i].use === '终点经度' || this.configArray[i].use === '起点纬度' ||this.configArray[i].use === '终点纬度' || this.configArray[i].use === '起点(纬度,经度)' || this.configArray[i].use === '终点(纬度,经度)'|| this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                return true
                            }
                        }else if(val === '终点(经度,纬度)'){
                            if (this.configArray[i].use === '终点(经度,纬度)' ||this.configArray[i].use === '起点经度' ||this.configArray[i].use === '终点经度' || this.configArray[i].use === '起点纬度' ||this.configArray[i].use === '终点纬度' || this.configArray[i].use === '起点(纬度,经度)' || this.configArray[i].use === '终点(纬度,经度)'|| this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                return true
                            }
                        }else if(val === '起点(纬度,经度)'){
                            if (this.configArray[i].use === '起点(纬度,经度)' ||this.configArray[i].use === '起点经度' ||this.configArray[i].use === '终点经度' || this.configArray[i].use === '起点纬度' ||this.configArray[i].use === '终点纬度' || this.configArray[i].use === '起点(经度,纬度)' || this.configArray[i].use === '终点(经度,纬度)'|| this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                return true
                            }
                        }else if(val === '终点(纬度,经度)'){
                            if (this.configArray[i].use === '终点(纬度,经度)' ||this.configArray[i].use === '起点经度' ||this.configArray[i].use === '终点经度' || this.configArray[i].use === '起点纬度' ||this.configArray[i].use === '终点纬度' || this.configArray[i].use === '起点(经度,纬度)' || this.configArray[i].use === '终点(经度,纬度)'|| this.configArray[i].use === '坐标串(经度,纬度)'||this.configArray[i].use === '坐标串(纬度,经度)') {
                                return true
                            }
                        }else if(val === '坐标串(经度,纬度)' ||val === '坐标串(纬度,经度)'){
                            if(this.configArray[i].use !== '数值'){
                                return true
                            }
                        }else if(val === '数值'){
                            if(this.configArray[i].use === '数值'){
                                return true
                            }
                        }
                    }
                }
                return false
            },
            configToTable(){
                for(let j = 0;j<this.tableHeadList.length;j++){
                    this.tableHeadList[j].use = ''
                }
                for(let i =0 ;i< this.configArray.length;i++){
                    for(let j = 0;j<this.tableHeadList.length;j++){
                        if(this.configArray[i].col === this.tableHeadList[j].col){
                            this.tableHeadList[j].use = this.configArray[i].use
                        }
                    }
                }
            },
            checkPointConfig(){
                let temp1 = 0
                let temp2 = 0
                this.configNoArray = []
                this.isConfigAll = false
                for(let i =0;i< this.configArray.length;i++){
                    if(this.configArray[i].use.indexOf('经度') !== -1){
                        temp1=temp1+1
                    }
                    if(this.configArray[i].use.indexOf('纬度') !== -1){
                        temp2=temp2+1
                    }
                }
                if(temp1 === 0){
                    this.configNoArray.push({use:'经度'})
                }
                if(temp2 === 0){
                    this.configNoArray.push({use:'纬度'})
                }
                if(temp1+temp2 === 2){
                    this.isConfigAll = true
                }
                if(temp1 === 0 && temp2 === 0){
                    this.configNoArray = []
                    this.isConfigAll = false
                }
            },
            checkLineConfig(){
                this.configNoArray = []
                this.isConfigAll = false
                let temp1 = 0 //起经
                let temp2 = 0//起纬度
                let temp3 = 0 //终点经度
                let temp4 = 0 //终点纬度
                for(let i =0;i< this.configArray.length;i++){
                    if(this.configArray[i].use.indexOf('起点经度') !== -1 || this.configArray[i].use.indexOf('起点(经度,纬度)') !== -1 ||this.configArray[i].use.indexOf('起点(纬度,经度)') !== -1 || this.configArray[i].use.indexOf('坐标串') !== -1){
                        temp1=temp1+1
                    }
                    if(this.configArray[i].use.indexOf('起点纬度') !== -1 || this.configArray[i].use.indexOf('起点(经度,纬度)') !== -1 ||this.configArray[i].use.indexOf('起点(纬度,经度)') !== -1 || this.configArray[i].use.indexOf('坐标串') !== -1){
                        temp2=temp2+1
                    }
                    if(this.configArray[i].use.indexOf('终点经度') !== -1 || this.configArray[i].use.indexOf('终点(经度,纬度)') !== -1 ||this.configArray[i].use.indexOf('终点(纬度,经度)') !== -1 || this.configArray[i].use.indexOf('坐标串') !== -1){
                        temp3=temp3+1
                    }
                    if(this.configArray[i].use.indexOf('终点纬度') !== -1 || this.configArray[i].use.indexOf('终点(经度,纬度)') !== -1 ||this.configArray[i].use.indexOf('终点(纬度,经度)') !== -1 || this.configArray[i].use.indexOf('坐标串') !== -1){
                        temp4=temp4+1
                    }
                }

                if(this.configArray.length !== 0){
                    if(this.configArray[0].use === '起点经度' || this.configArray[0].use === '起点纬度'||this.configArray[0].use === '终点经度' || this.configArray[0].use === '终点纬度'){
                        if(temp1 === 0){
                            this.configNoArray.push({use:'起点经度'})
                        }
                        if(temp2 === 0){
                            this.configNoArray.push({use:'起点纬度'})
                        }
                        if(temp3 === 0){
                            this.configNoArray.push({use:'终点经度'})
                        }
                        if(temp4 === 0){
                            this.configNoArray.push({use:'终点纬度'})
                        }
                    }else if(this.configArray[0].use === '起点(经度,纬度)' || this.configArray[0].use === '终点(经度,纬度)'){
                        if(temp1 === 0){
                            this.configNoArray.push({use:'起点(经度,纬度)'})
                        }
                        if(temp3 === 0){
                            this.configNoArray.push({use:'终点(经度,纬度)'})
                        }
                    }else if(this.configArray[0].use === '起点(纬度,经度)' || this.configArray[0].use === '终点(纬度,经度)'){
                        if(temp2 === 0){
                            this.configNoArray.push({use:'起点(纬度,经度)'})
                        }
                        if(temp4 === 0){
                            this.configNoArray.push({use:'终点(纬度,经度)'})
                        }
                    }

                    if(temp1+temp2+temp3+temp4=== 4){
                        this.isConfigAll = true
                    }
                    if(temp1 === 0 && temp2 === 0&&temp3 === 0&&temp4 === 0){
                        this.configNoArray = []
                        this.isConfigAll = false
                    }
                }
            },
            //生成图层
            createLayer(){
                this.$emit('setLoading')
                this.$axios({
                    method:"post",
                    url:"/authorApi/userAnnex/createCite",
                    data:{
                        annexId:this.selectAnnexId,
                        type:this.layerAreaType,
                        style:this.layerTypeSelect,
                        detailUses:this.configArray,
                        fileId:this.$store.state.currFolderId
                    }
                }).then((res)=>{
                    if(res.data.status === 200){
                        this.$store.state.dataVizLayerList.push(res.data.data)
                        this.$emit("createLayerOk",res.data.data.layerId)
                    }else{
                        this.$store.state.snackbarShow = true
                        this.$store.state.snackbarText = res.data.message
                        this.$store.state.snackbarType = 'error_red'
                    }
                    this.$emit('closeLoading')
                }).catch(()=>{
                    this.$emit('closeLoading')
                    this.$store.state.snackbarShow = true
                    this.$store.state.snackbarText = '创建失败'
                    this.$store.state.snackbarType = 'error_red'
                })
            },

            //点击图层查看进入我的数据查看
            viewAnnexDialogData(){
                this.$emit('setLoading')
                this.$axios.get('/authorApi/userAnnex/readAnnex', {
                    params: {
                        annexId: this.$store.state.selectLayerTreeNode.data.annexId
                    }
                }).then((res) => {
                    //关闭loading
                    this.$emit('closeLoading')
                    if (res.data.status === 200) {
                        this.selectAnnexRow = res.data.data.height
                        this.selectAnnexCol = res.data.data.weight
                        this.selectAnnexData = res.data.data.lists
                        this.selectAnnexDataTotalRow = res.data.data.totalCol

                        this.rightDataArea = '数据区'
                        //id赋值
                        this.selectAnnexId =this.deepClone(this.$store.state.selectLayerTreeNode.data.annexId)
                        //生成数组
                        this.tableHeadList = []
                        for (let i = 0; i < res.data.data.tableTitleList.length; i++) {
                            this.tableHeadList.push({
                                col: i,
                                use: '',
                                text:res.data.data.tableTitleList[i]
                            })
                        }
                        this.configArray = this.deepClone(this.$store.state.selectLayerTreeNode.data.annexColUse)
                        this.layerAreaType = this.deepClone(this.$store.state.selectLayerTreeNode.data.type)
                        this.layerTypeSelect = this.deepClone(this.$store.state.selectLayerTreeNode.data.style)
                        this.configToTable()
                        if(this.$store.state.selectLayerTreeNode.data.type ==='point'){
                            this.checkPointConfig()
                        }else{
                            this.checkLineConfig()
                        }
                    } else {
                        this.$store.state.snackbarShow = true
                        this.$store.state.snackbarText = res.data.message
                        this.$store.state.snackbarType = 'error_red'
                    }

                }).catch(() => {
                    this.$store.state.snackbarShow = true
                    this.$store.state.snackbarText = "数据获取失败"
                    this.$store.state.snackbarType = 'error_red'
                })
            },
            deepClone(obj){
                let tmp = JSON.stringify(obj)
                return JSON.parse(tmp)
            },
        },
        mounted() {
            this.getAnnexList('')
        }
    }
</script>

<style scoped>
    .dataAreaTab{
        position:relative;
        width:75px;
        height:32px;
        margin-top:3px;
    }
    .dataAreaTab_text{
        line-height:25px;
        text-align:center;
        font-size:18px;
        cursor:pointer;
    }
    .dataAreaTab_line{
        position:absolute;
        bottom:0;
        left:21px;
        width:32px;
        height:5px;
        background:#20518A;
        border-radius:5px;
        margin-top:2px;
    }
    .dataAreaType{
        width:100%;
        height:84px;
        border-radius:5px;
        border:1px solid #E5E5E5;
        margin-bottom:15px;
        padding:0 21px 0 22px;
        display:flex;
        align-items:center;
    }
    .dataAreaType:hover{
        border-color:#2A82E4;
    }
    .dataAreaType_btn{
        font-size:22px;
        color:#2A82E4;
        cursor:pointer;
        display:none;
    }
    .dataAreaType:hover .dataAreaType_btn{
        display:block;
    }

    .layerAreaTab{
        position:relative;
        width:75px;
        height:32px;
        margin-top:15px;
    }
    .layerAreaTab_text{
        line-height:25px;
        text-align:center;
        font-size:18px;
        cursor:pointer;
    }
    .layerAreaTab_line{
        position:absolute;
        bottom:0;
        left:21px;
        width:32px;
        height:5px;
        background:#20518A;
        border-radius:5px;
        margin-top:2px;
    }
    .layerAreaType{
        width:100%;
        height:84px;
        border-radius:5px;
        border:1px solid #E5E5E5;
        margin-bottom:15px;
        padding:0 21px 0 22px;
        display:flex;
        align-items:center;
    }
    .layerAreaType:hover{
        border-color:#2A82E4;
    }
    .layerAreaType_btn{
        font-size:22px;
        color:#2A82E4;
        cursor:pointer;
        display:none;
    }


</style>
<style>
    .annexTextField .v-input__slot{
        min-height: 36px !important;
    }
    .fileNameTextField .v-input__slot{
        min-height: 36px !important;
    }
    .myAnnexData::-webkit-scrollbar-track-piece{
        -webkit-border-radius:0;
    }
    .myAnnexData::-webkit-scrollbar {
        width: 4px; /*对垂直滚动条有效*/
    }
    /*定义滚动条的轨道颜色、内阴影及圆角*/
    /*.myAnnexData::-webkit-scrollbar-track {*/
    /*    background-color: #FFFFFF;*/
    /*}*/
    /*定义滑块颜色、内阴影及圆角*/
    .myAnnexData::-webkit-scrollbar-thumb {
        background-color: rgba(229, 229, 229, 1);
        -webkit-border-radius:1px;
        border: 1px solid rgba(229, 229, 229, 1);
    }
    .myTableData::-webkit-scrollbar {
        width: 4px; /*对垂直滚动条有效*/
        height: 4px;  /*对水平滚动条有效*/
    }
    /*定义滚动条的轨道颜色、内阴影及圆角*/
    .myTableData::-webkit-scrollbar-track {
        background-color: #FFFFFF;
    }
    /*定义滑块颜色、内阴影及圆角*/
    .myTableData::-webkit-scrollbar-thumb {
        background-color: rgba(229, 229, 229, 1);
        border-radius: 2px;
    }
</style>
